<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>服务定制下单</span>
      </div>
      
      <el-form 
        ref="orderForm" 
        :model="form" 
        :rules="rules" 
        label-width="140px"
        class="order-form"
      >
        <!-- 教练选择 -->
        <el-form-item label="选择教练" prop="coach_id">
          <div style="display: flex; align-items: center;">
            <el-input 
              v-model="selectedCoachDisplay" 
              placeholder="请选择教练"
              readonly
              style="flex: 1; margin-right: 10px"
            >
              <template slot="prepend">教练</template>
            </el-input>
            <el-button type="primary" @click="openCoachSelect">选择教练</el-button>
          </div>
          <div class="form-tip" v-if="selectedCoach.id">
            已选：{{ selectedCoach.real_name || selectedCoach.name }} | {{ selectedCoach.phone }} | {{ selectedCoach.city }}
          </div>
        </el-form-item>

        <!-- 教练选择弹窗 -->
        <coach-select-dialog 
          :visible.sync="coachSelectVisible"
          @select="handleCoachSelect"
        ></coach-select-dialog>

        <!-- 服务名称 -->
        <el-form-item label="服务名称" prop="title">
          <el-input 
            v-model="form.title" 
            placeholder="请输入服务名称"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>

        <!-- 服务类目 -->
        <el-form-item label="服务类目" prop="categories">
          <el-select 
            v-model="form.categories" 
            placeholder="请选择服务类目"
            style="width: 100%"
          >
            <el-option 
              v-for="item in categoriesList" 
              :key="item.id" 
              :label="item.name" 
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- 单次时长 -->
        <!-- <el-form-item label="单次时长(分钟)" prop="length_of_lesson">
          <el-input-number 
            v-model="form.length_of_lesson" 
            :min="30" 
            :max="300"
            :step="30"
            placeholder="请输入单次时长"
            style="width: 100%"
          ></el-input-number>
          <div class="form-tip">建议设置30-300分钟</div>
        </el-form-item> -->

        <!-- 服务次数 -->
        <el-form-item label="服务总次数" prop="course_num">
          <el-input-number 
            v-model="form.course_num" 
            :min="1" 
            :max="100"
            placeholder="请输入服务总次数"
            style="width: 100%"
          ></el-input-number>
          <div class="form-tip" v-if="totalCourseHours > 0">
            总课时: {{ totalCourseHours }} 小时（单次{{ form.length_of_lesson }}分钟 × {{ form.course_num }}次）
          </div>
        </el-form-item>

        <!-- 服务总价 -->
        <el-form-item label="单节价格" prop="single_amount">
          <el-input-number 
            v-model="form.single_amount" 
            :min="0" 
            :precision="2"
            :step="100"
            placeholder="请输入单节价格"
            style="width: 100%"
          ></el-input-number>
          <div class="form-tip" v-if="totalAmount > 0">
            总价: {{ totalAmount }} 元
          </div>
        </el-form-item>

        <!-- 教练单次结算价格 -->
        <el-form-item label="教练单次结算价(元)" prop="coach_settlement_cash">
          <el-input-number 
            v-model="form.coach_settlement_cash" 
            :min="0" 
            :precision="2"
            :step="50"
            placeholder="请输入教练单次结算价格"
            style="width: 100%"
          ></el-input-number>
          <div class="form-tip" v-if="totalSettlement > 0">
            总结算价: {{ totalSettlement }} 元
          </div>
        </el-form-item>

        <!-- 分隔线 -->
        <el-divider content-position="left">支付信息</el-divider>

        <!-- 用户电话 -->
        <el-form-item label="用户电话" prop="user_phone">
          <el-input 
            v-model="form.user_phone" 
            placeholder="请输入用户手机号"
            maxlength="11"
          ></el-input>
        </el-form-item>

        <!-- 用户姓名 -->
        <el-form-item label="用户姓名" prop="user_name">
          <el-input 
            v-model="form.user_name" 
            placeholder="请输入用户姓名"
            maxlength="20"
          ></el-input>
        </el-form-item>

        <!-- 预约时间 -->
        <el-form-item label="预约时间" prop="appointment_time">
          <el-date-picker
            v-model="form.appointment_time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm"
            :default-time="['12:00:00', '14:00:00']"
            style="width: 100%"
          >
          </el-date-picker>
          <div class="form-tip">例如：2026-05-06 12:00 至 2026-05-06 14:00</div>
          <!-- 显示预约时长 -->
          <div class="form-tip" v-if="appointmentTotalHours > 0" style="color: #409EFF; margin-top: 5px;">
            预约时长：{{ appointmentTotalHours }} 小时
          </div>
        </el-form-item>

        <!-- 支付方式 -->
        <el-form-item label="支付方式" prop="payment_method">
          <el-radio-group v-model="form.payment_method">
            <el-radio label="qr">支付</el-radio>
            <el-radio label="credit">挂账</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 地址类型选择 -->
        <el-form-item label="服务地址类型" required>
          <el-radio-group v-model="addressType" @change="handleAddressTypeChange">
            <el-radio label="venue">选择共享场馆</el-radio>
            <el-radio label="custom">自定义地址</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 共享场馆选择 -->
        <template v-if="addressType === 'venue'">
          <el-form-item label="选择共享场馆" prop="venue_id">
            <shared-venue-select 
              ref="venueSelect"
              :venueid.sync="form.venue_id"
              @change="handleVenueChange"
              placeholder="请输入场馆名称"
            ></shared-venue-select>
          </el-form-item>
          
          <el-form-item label="场馆信息" v-if="selectedVenue.name">
            <el-descriptions :column="2" border>
              <el-descriptions-item label="场馆名称">
                {{ selectedVenue.name }}
              </el-descriptions-item>
              <el-descriptions-item label="地址">
                {{ selectedVenue.address }}
              </el-descriptions-item>
              <el-descriptions-item label="城市">
                {{ selectedVenue.city }}
              </el-descriptions-item>
              <el-descriptions-item label="联系人">
                {{ selectedVenue.contacts }}
              </el-descriptions-item>
            </el-descriptions>
          </el-form-item>
        </template>

        <!-- 自定义地址 -->
        <template v-if="addressType === 'custom'">
          <el-form-item label="省市区" prop="city">
            <city-select 
              @change="handleCityChange" 
              :temp="cityList"
            ></city-select>
          </el-form-item>

          <el-form-item label="详细地址" prop="address">
            <el-input 
              v-model="form.address" 
              placeholder="请输入详细地址"
              type="textarea"
              :rows="2"
            >
              <addr-select 
                slot="append"
                @getform="handleAddrSelect"
                type="icon"
              ></addr-select>
            </el-input>
          </el-form-item>

          <el-form-item label="经度" prop="longitude">
            <el-input 
              v-model="form.longitude" 
              placeholder="请输入经度"
            ></el-input>
          </el-form-item>

          <el-form-item label="纬度" prop="latitude">
            <el-input 
              v-model="form.latitude" 
              placeholder="请输入纬度"
            ></el-input>
          </el-form-item>
        </template>

        <!-- 提交按钮 -->
        <el-form-item>
          <el-button 
            type="primary" 
            @click="submitOrder"
            :loading="submitLoading"
          >提交订单</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    
    <!-- 二维码展示对话框 -->
    <el-dialog 
      title="支付二维码" 
      :visible.sync="qrCodeDialogVisible" 
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="text-align: center;">
        <img 
          :src="qrCodeUrl" 
          alt="支付二维码" 
          style="width: 300px; height: 300px;"
        />
        <p style="margin-top: 20px; color: #666;">请使用微信或支付宝扫码支付</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrCodeDialogVisible = false">关 闭</el-button>
        <!-- <el-button type="primary" @click="reOrder">重新下单</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CoachSelectDialog from '@/components/select/CoachSelectDialog.vue';
import sharedVenueSelect from '@/components/select/sharedVenueSelect.vue';
import citySelect from '@/components/select/citySelect.vue';
import addrSelect from '@/components/addrSelect.vue';

export default {
  name: 'CreateOrder',
  components: {
    CoachSelectDialog,
    sharedVenueSelect,
    citySelect,
    addrSelect
  },
  data() {
    return {
      nav: { 
        firstNav: '定制管理', 
        secondNav: '创建订单' 
      },
      
      // 地址类型: venue-共享场馆, custom-自定义地址
      addressType: 'venue',
      
      // 表单数据
      form: {
        coach_id: '',
        title: '',
        categories: '',
        length_of_lesson: 60,
        course_num: 1,
        single_amount: 0,
        coach_settlement_cash: 0,
        settlement_type: '1',
        
        // 支付信息
        user_phone: '',
        user_name: '',
        appointment_time: [],
        payment_method: 'qr',
        
        // 场馆相关
        venue_id: '',
        
        // 地址相关
        province: '',
        city: '',
        district: '',
        address: '',
        latitude: '',
        longitude: ''
      },
      
      // 选中的教练信息
      selectedCoach: {},
      
      // 教练选择弹窗显示状态
      coachSelectVisible: false,
      
      // 选中的场馆信息
      selectedVenue: {},
      
      // 城市列表
      cityList: [],
      
      // 类目列表
      categoriesList: [],
      
      // 二维码对话框
      qrCodeDialogVisible: false,
      qrCodeUrl: '',
      
      // 表单验证规则
      rules: {
        coach_id: [
          { required: true, message: '请选择教练', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入服务名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        categories: [
          { required: true, message: '请选择服务类目', trigger: 'change' }
        ],
        length_of_lesson: [
          { required: true, message: '请输入单次时长', trigger: 'blur' }
        ],
        course_num: [
          { required: true, message: '请输入服务总次数', trigger: 'blur' }
        ],
        single_amount: [
          { required: true, message: '请输入服务总价', trigger: 'blur' }
        ],
        coach_settlement_cash: [
          { required: true, message: '请输入教练单次结算价格', trigger: 'blur' }
        ],
        user_phone: [
          { required: true, message: '请输入用户电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        user_name: [
          { required: true, message: '请输入用户姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        payment_method: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ],
        city: [
          { 
            required: true, 
            message: '请选择省市区', 
            trigger: 'change',
            validator: this.validateCity
          }
        ],
        address: [
          { 
            required: true, 
            message: '请输入详细地址', 
            trigger: 'blur',
            validator: this.validateAddress
          }
        ]
      },
      
      // 提交加载状态
      submitLoading: false,
      
      // 二维码对话框显示状态
      qrCodeDialogVisible: false,
      
      // 二维码图片URL
      qrCodeUrl: ''
    };
  },
  
  created() {
    this.getCategoryList();
  },
  
  computed: {
    // 计算总结算价
    totalSettlement() {
      if (this.form.coach_settlement_cash && this.form.course_num) {
        return (this.form.coach_settlement_cash * this.form.course_num).toFixed(2);
      }
      return 0;
    },
    totalAmount(){
         if (this.form.single_amount && this.form.course_num) {
        return (this.form.single_amount * this.form.course_num).toFixed(2);
      }
      return 0;
    },
    
    // 显示已选教练的信息
    selectedCoachDisplay() {
      if (this.selectedCoach.id) {
        return `${this.selectedCoach.real_name || this.selectedCoach.name}`;
      }
      return '';
    },
    
    // 计算预约总时长（小时）
    appointmentTotalHours() {
      if (this.form.appointment_time && this.form.appointment_time.length === 2) {
        const startTime = new Date(this.form.appointment_time[0]);
        const endTime = new Date(this.form.appointment_time[1]);
        
        // 计算时间差（毫秒）
        const diffMs = endTime.getTime() - startTime.getTime();
        
        // 转换为小时，保留两位小数
        const hours = (diffMs / (1000 * 60 * 60)).toFixed(2);
        
        return parseFloat(hours);
      }
      return 0;
    },
    
    // 计算总课时数（小时）
    totalCourseHours() {
      // 单次时长（分钟）× 课程次数 ÷ 60 = 总小时数
      if (this.form.length_of_lesson && this.form.course_num) {
        const totalMinutes = this.form.length_of_lesson * this.form.course_num;
        const hours = (totalMinutes / 60).toFixed(2);
        return parseFloat(hours);
      }
      return 0;
    }
  },
  
  methods: {
    // 获取类目列表
    getCategoryList() {
      let url = "/user/mechanismCategory/queryListPageChild";
      let data = {
        status: 2,
        type: 2,
        source: '课程'
      };
      this.$axios
        .get(url, {
          params: data,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.categoriesList = res.data.data || [];
          }
        })
        .catch(err => {
          console.error('获取类目列表失败:', err);
        });
    },
    
    // 打开教练选择弹窗
    openCoachSelect() {
      this.coachSelectVisible = true;
    },
    
    // 教练选择
    handleCoachSelect(coach) {
      this.selectedCoach = coach;
      this.form.coach_id = coach.id;
      this.coachSelectVisible = false;
    },
    
    // 场馆选择变化
    handleVenueChange(venue) {
      this.selectedVenue = venue;
      this.form.venue_id = venue.id;
      
      // 自动填充场馆的地址信息
      if (venue) {
        this.form.province = venue.province || '';
        this.form.city = venue.city || '';
        this.form.district = venue.district || '';
        this.form.address = venue.address || '';
        this.form.latitude = venue.latitude || '';
        this.form.longitude = venue.longitude || '';
      }
      
      console.log('选中场馆:', venue);
    },
    
    // 地址类型变化
    handleAddressTypeChange(type) {
      // 切换时清空相关字段
      if (type === 'venue') {
        this.form.province = '';
        this.form.city = '';
        this.form.district = '';
        this.form.address = '';
        this.form.latitude = '';
        this.form.longitude = '';
        this.cityList = [];
      } else {
        this.form.venue_id = '';
        this.selectedVenue = {};
        if (this.$refs.venueSelect) {
          this.$refs.venueSelect.clear();
        }
      }
      
      // 清除验证
      this.$nextTick(() => {
        this.$refs.orderForm.clearValidate();
      });
    },
    
    // 城市选择变化
    handleCityChange(cityData) {
      this.form.province = cityData[0] || '';
      this.form.city = cityData[1] || '';
      this.form.district = cityData[2] || '';
      this.cityList = [
        ...cityData
      ];
    },
    
    // 地址选择器变化
    handleAddrSelect(addr) {
      this.form.province = addr.province || '';
      this.form.city = addr.city || '';
      this.form.district = addr.district || '';
      this.cityList = [
        addr.province || '',
        addr.city || '',
        addr.district || ''
      ];
      
      // 如果有经纬度信息，自动填充
      if (addr.addrPoint) {
        this.form.longitude = addr.addrPoint.lng || '';
        this.form.latitude = addr.addrPoint.lat || '';
      }
    },
    
    // 验证场馆（当选择共享场馆时）
    validateVenue(rule, value, callback) {
      if (this.addressType === 'venue' && !value) {
        callback(new Error('请选择共享场馆'));
      } else {
        callback();
      }
    },
    
    // 验证城市（当选择自定义地址时）
    validateCity(rule, value, callback) {
      if (this.addressType === 'custom' && !this.form.city) {
        callback(new Error('请选择省市区'));
      } else {
        callback();
      }
    },
    
    // 验证地址（当选择自定义地址时）
    validateAddress(rule, value, callback) {
      if (this.addressType === 'custom' && !value) {
        callback(new Error('请输入详细地址'));
      } else {
        callback();
      }
    },
    
    // 验证预约时间
    validateAppointmentTime(rule, value, callback) {
      if (value && value.length === 2) {
        callback();
      } else {
        callback(new Error('请选择预约时间'));
      }
    },
    
    // 提交订单
    submitOrder() {
      this.$refs.orderForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          
          // 构建提交数据
          const submitData = {
            coach_id: this.form.coach_id, 
            title: this.form.title,
            amount: this.totalAmount,
            length_of_lesson: this.form.length_of_lesson,
            course_num: this.form.course_num,
            city: this.form.city,
            province: this.form.province,
            district: this.form.district,
            address: this.form.address,
            coach_name: this.selectedCoach.name || '',
            latitude: this.form.latitude,
            longitude: this.form.longitude,
            categories: this.form.categories,
            settlement_type: this.form.settlement_type,
            coach_settlement_cash: this.form.coach_settlement_cash,
            venue_id: this.addressType === 'venue' ? this.form.venue_id : null,
            is_receiving: 0,
            type: 'service',
            create_type: 11,
            // 支付信息
            phone: this.form.user_phone,
            name: this.form.user_name,
            pay_type: this.form.payment_method,
            rcharge_type: 'coach_service',
          };
          
            if(this.form.appointment_time){
                submitData.appointment_time = this.form.appointment_time[0]
                submitData.number_of_lessons = this.appointmentTotalHours
            }
          
          // 调用API提交订单
          this.$axios({
            url: '/user/userCourseNeed/generateCustomService',
            method: 'post',
            data: submitData
          }).then(res => {
            this.submitLoading = false;
            this.form.user_phone = ''
            this.form.user_name = ''
           // 判断是否返回二维码图片
              if (res.data.data && res.data.data.img) {
                this.$message.success('订单创建成功');
                this.qrCodeUrl = res.data.data.img;
                this.qrCodeDialogVisible = true;
              } else {
                this.$message.success('订单创建成功');
              }
          }).catch(err => {
            this.submitLoading = false;
            this.$message.error('网络错误，请稍后重试');
            console.error('提交失败:', err);
          });
        } else {
          this.$message.warning('请完善表单信息');
          return false;
        }
      });
    },
    
    // 重置表单
    resetForm() {
      this.$refs.orderForm.resetFields();
      this.addressType = 'venue';
      this.selectedCoach = {};
      this.selectedVenue = {};
      this.cityList = [];
      this.form = {
        coach_id: '',
        title: '',
        categories: '体育运动',
        length_of_lesson: 60,
        course_num: 1,
        single_amount: 0,
        coach_settlement_cash: 0,
        settlement_type: '1',
        
        // 支付信息
        user_phone: '',
        user_name: '',
        appointment_time: [],
        payment_method: 'pay',
        
        venue_id: '',
        province: '',
        city: '',
        district: '',
        address: '',
        latitude: '',
        longitude: ''
      };
      
      // 清空组件内部状态
      if (this.$refs.venueSelect) {
        this.$refs.venueSelect.clear();
      }
    },
    
    // 重新下单
    reOrder() {
      this.qrCodeDialogVisible = false;
      this.resetForm();
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
}

.box-card {
  margin-top: 20px;
}

.order-form {
  max-width: 800px;
  
  .form-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
  }
}

.clearfix {
  &:after {
    content: "";
    display: table;
    clear: both;
  }
}
</style>
